import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { UtilsService } from '../../rl-common/shared/core/utils.service';
import { PageNavigationComponent } from '../../rl-common/page-navigation/page-navigation.component';
import { SearchComponent } from '../../rl-common/search/search.component';
import { AnnotatorDesignToolsComponent } from '../../annotations/annotator-design-tools/annotator-design-tools.component';
import { ToolbarOptionsConfig } from './toolbar-options-config';
import { ContainerService } from '../../ajs-upgraded-providers';
import { EntityType } from '../../rl-common/shared/shared/entity-type.enum';
import { Type } from '../../annotations/shared/Tools/annotator-tool';

@Component({
  selector: 'rl-toolbar',
  templateUrl : './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent implements OnInit, OnDestroy {

  @Output() onSelectTool = new EventEmitter<any>();
  @Input() page : number = 1;
  @Input() config? : ToolbarOptionsConfig = new ToolbarOptionsConfig();
  @Input() entityType: EntityType;

  @ViewChild(SearchComponent) searchComp : SearchComponent;
  @ViewChild(PageNavigationComponent) pageNav : PageNavigationComponent;
  @ViewChild(AnnotatorDesignToolsComponent) designTools : AnnotatorDesignToolsComponent;

  rotation : number = 0;
  currentPage : number = 1;
  showFileSearch : boolean = false;
  originalRightPanelState : boolean = null;
  isIframe : boolean = false;
  disabledDesignTools : string[];
  showAnnotations : boolean = true;

  zoomOptions : {value : string, label : string}[] = [
    {value : "0.2", label: "20%"},
    {value : "0.5", label: "50%"},
    {value : "1", label: "100%"},
    {value : "1.33", label: "133%"},
    {value : "1.5", label: "150%"},
    {value : "2", label: "200%"}
  ];

  zoom = this.zoomOptions[2];

  selectedTool : ToolbarOptions;

  constructor(private containerService : ContainerService, private utils : UtilsService) { 
    this.isIframe = utils.isIframe();
  }

  ngOnInit(): void {
    this.showAnnotations = !this.utils.isTouchScreen() && this.entityType !== EntityType.COLLECTION;
  }

  selectTool = (toolName : ToolbarOptions, options? : any) => this.onSelectTool.emit({toolName: toolName, value : options});

  toggleSelectTool = (toolName) => {
    this.selectTool(toolName, !this.isToolSelected(toolName));
    this.selectedTool = this.isToolSelected(toolName) ? "none" : toolName;
  }

  isToolSelected = (toolName) : boolean => this.selectedTool === toolName;

  pageChanged = (e) => this.selectTool("page", {page : e});
  search = (e) => this.onSelectTool.emit({toolName: "search", value : e});
  nextResult= () => this.onSelectTool.emit({toolName: "nextResult"});

  rotate(){
    this.rotation = (this.rotation + 90) % 360;
    this.selectTool("rotation", {rotation : this.rotation});
  }

  changeZoom(e){
    this.zoom = e;
    this.selectTool("zoom", {zoom : this.zoom.value});
  }

  openInNewTab = () => this.utils.openInNewTab();

  fullScreen(){
    if(this.originalRightPanelState === null) this.originalRightPanelState = this.containerService.get("hideRightPanelActive");
    let fs = !this.containerService.get("shrinkCitationDetails");
    this.containerService.put("hideRightPanelActive", fs || this.originalRightPanelState);
    this.containerService.put("shrinkCitationDetails", fs);
    //this.selectTool("fullScreen", {fullScreen : fs});
    //this.changeZoom(this.zoomOptions[2]);
    
  }

  update(conf){
    this.pageNav.totalPages = conf.totalPages || this.pageNav.totalPages;
    this.searchComp.totalResults = conf.totalSearchResults || this.searchComp.totalResults;
  }
  
  disableDesignTools = (toolsDisabled : any[]) => this.disabledDesignTools = toolsDisabled;

  ngOnDestroy(): void {
    this.containerService.put("hideRightPanelActive", this.originalRightPanelState);
  }
}